export default __webpack_public_path__ + "static/media/uploader-ascensiaContourNextMeter-2.f3eca456.png";